const operateTypeEnum = {
  select: '查询',
  add: '新增',
  update: '修改',
  delete: '删除',
  import: '导入',
  export: '导出',
  update_state: '修改状态',
};

const operateBizTypeEnum = {
  user: '人员',
  role: '角色',
  menu: '菜单',
  organization: '组织',
  position: '岗位',
  menuPermission:'菜单权限',
  elements:'元素',
  roleUser:'角色人员',
  roleSets:'角色组',
  organizationNodeCategory:'组织类型',
  organizationManager:'权限管理',
  positionCategory:'岗位分类',
  resetPassword:'密码重置',
  programCategory:'课程分类',
  schedule:'课件',
  program:'课程',
  courseware:"第三方课件",
  trainPath:"培训路径",
  trainPathComment:'路径评语',
  studentComment:'路径评语审核',
  series:'系列化课程',
  seriesContent:'系列化课程内容',
  interactLive:'直播',
  liveTrainingRecord:'直播参训记录',
  liveTrainingStatistics:'直播参训统计',
  question:'题目',
  examTemplate:'考试模板',
  examTemplateGroup:'模板组',
  examTemplateGroupManage:'模板组管理',
};


const statusEnum = {
  success: '成功',
  error: '失败',
}

const generateDict = (obj = {}) => {
  return Object.keys(obj).map(key => ({code: key, codeName: obj[key]}))
}

export {
  operateTypeEnum,
  operateBizTypeEnum,
  statusEnum,
  generateDict,
}
